<template>
  <div class="modal__wrap--bg cmp-modal" id="mypage-education-detail-template" :class="{'is-active' : showModal}"
       role="dialog" aria-modal="true" aria-labelledby="detail-modal-title">
    <div class="modal-wrap-container modal-wd1020" ref="mainModalBody" tabindex="-1">
      <div class="modal-header">
        <div class="title" id="detail-modal-title">강좌 상세 정보</div>
      </div>
      <div class="modal-body-container">
        <div class="table-wrap no-line-mg">
          <table class="table-body-only">
            <caption>강좌 상세 정보 테이블</caption>
            <colgroup class="pc-cell">
              <col style="width: 160px;" />
              <col />
            </colgroup>
            <colgroup class="mo-cell">
              <col style="width: 88px;" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">중분류</th>
                <td>{{ course.term }}</td>
              </tr>
              <tr>
                <th scope="row">강좌명</th>
                <td>{{ course.title }}</td>
              </tr>
              <tr>
                <th scope="row">교육기간</th>
                <td>{{ course.courseStartDate }} ~ {{ course.courseEndDate }}</td>
              </tr>
              <tr>
                <th scope="row">참여자 단계</th>
                <td>{{ course.statusNm }}</td>
              </tr>
              <tr v-if="showWaitingNo">
                <th scope="row">대기 순번</th>
                <td>{{ course.waitingNo }}번 / 전체 {{ course.waitingTotal }}명</td>
              </tr>
              <tr>
                <th scope="row">결제정보</th>
                <td>
                  <template v-if="showPaymentButtons">
                    <a class="btn btn-gray btn-sm" v-if="showCashButton" @click="openCashInfo" data-courseId="${course.id}" title="현금이체정보">현금이체정보</a>
                    <a :href="`/mypage-education-pay.do?id=${id}`" class="btn btn-gray btn-sm" v-else-if="showPayButton">결제하기</a>
                  </template>
                </td>
              </tr>
              <tr>
                <th scope="row">취소신청</th>
                <td>
                  <button type="button" class="btn btn-gray btn-sm course-cancel-btn"
                    v-if="showCancleButton" @click="courseCancel"
                    data-type="getCancelType" data-courseId="${course.id}" >취소하기</button>
                </td>
              </tr>
              <tr>
                <th scope="row">이수 여부</th>
                <td>{{ completionStatus }}</td>
              </tr>
              <tr>
                <th scope="row">이수증 출력</th>
                <td>
                  <a href="javascript:void(0)" class="btn btn-gray btn-sm" v-if="showCompletePrintBtn" @click="completePrint" title="출력하기">출력하기</a>
                </td>
              </tr>
              <tr>
                <th scope="row">연계 공고</th>
                <td>
                  <a href="javascript:void(0)" class="btn btn-gray btn-sm" ref="jobLinkBtn" @click="openEducationJobLink" title="확인">확인</a>
                </td>
              </tr>
              <tr v-if="course.scheduleList && course.scheduleList.length > 0">
              	<th scope="row">교육 일정</th>
              	<td>
              	  <div style="overflow-x: auto;">
              	    <table class="table-body-only" id="schTable" style="min-width:400px;">
              	      <caption>교육일정표</caption>
              	      <thead>
              	        <tr>
              	          <th class="th-normal" style="width:34%">일시</th>
              	          <th class="th-normal" style="width:33%">장소</th>
              	          <th class="th-normal" style="width:33%">강사</th>
              	        </tr>
              	      </thead>
              	      <tbody>
              	        <tr v-for="item in course.scheduleList" :key="item.seq">
              	          <td class="td-normal">({{ item.seq }}회차) {{ item.date }}<br>({{ item.time }})</td>
              	          <td class="td-normal">{{ item.place }}</td>
              	          <td class="td-normal" v-html="item.lecturers"></td>
              	        </tr>
              	      </tbody>
              	    </table>
              	  </div>
              	</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-md button-wid150  close-modal" @click="closeModal">
          닫기
        </button>
      </div>
      <button type="button" class="btn btn-close only-icon close-modal" aria-label="닫기" @click="closeModal" title="닫기">
        <i class="ico ico-x-bl"></i>
      </button>
    </div>
    <course-cancel-button :type="getCancelType" :courseId="id" :showModal="courseCancelModal" :orgSe="course.orgSe" :paymentType="course.payment.type" @update:courseCancelModal="claseCourseCancelModal"></course-cancel-button>
    <cash-info-button :cashInfoModal="cashInfoModal" :courseId="id" @update:cashInfoModal="closeCashInfoModal"></cash-info-button>
    <education-job-link-modal :educationJobLinkModal="educationJobLinkModal" :isLogin="isLogin"
      :lectureNo="course.lectureNo" :title="course.title" @update:educationJobLinkModal="closeEducationJobLink"></education-job-link-modal>
  </div>
</template>

<script>
import Axios from 'axios';
import CourseCancelButton from './CourseCancelButton.vue';
import CashInfoButton from './CashInfoButton.vue';
import AttendanceModal from './AttendanceModal.vue';
import EducationJobLinkModal from './EducationJobLink.vue';

export default {
  name: 'mypage-education-detail-template',
  props: ['isLogin'],
  components: {
    CourseCancelButton, CashInfoButton, AttendanceModal, EducationJobLinkModal,
  },
  data() {
    return {
      showModal: false,
      id: '',
      type: '',
      ck: '',
      course: {
        lectureNo: '',
        title: '',
        term: '',
        courseStartDate: '',
        courseEndDate: '',
        status: '',
        statusNm: '',
        type: '',
        progress: '',
        progressCode: '',
        payment: {
          status: '',
          type: '',
        },
        viewIssue: '',
        orgSe: '',
        scheduleList: [],
        waitingNo: 0,
        waitingTotal: 0,
      },
      cashInfoModal: false,
      educationJobLinkModal: false,
      courseCancelModal: false,
    };
  },
  computed: {
    // 결제 버튼들을 보여줄지 여부
    showPaymentButtons() {
      const { status } = this.course;
      return status === 'PAYMENT_WAITING' || status === 'APP_PAYMENT_WAITING'
        || status === '결제대기' || status === '승인결제대기';
    },

    // 대기 순번을 보여줄지 여부 (대기신청 상태이고 순번이 산출된 경우)
    showWaitingNo() {
      const { status } = this.course;
      return (status === 'AWAITING' || status === '대기신청') && this.course.waitingNo > 0;
    },

    // 현금이체정보 버튼을 보여줄지 여부
    showCashButton() {
      return this.course.payment.status === 'CASH_WAITING';
    },

    // 결제하기 버튼을 보여줄지 여부
    showPayButton() {
      const paymentStatus = this.course.payment.status;
      return paymentStatus === null || paymentStatus === 'NONE';
    },

    // 취소 버튼을 보여줄지 여부
    showCancleButton() {
      const { status, progress, progressCode } = this.course;

      if (progress === 'CLOSED' || progressCode === 'CLOSED') {
        return false;
      }

      // 취소 가능한 강좌 타입 확인
      // const isCancelableType = ['FREE', 'FREE_CONFIRM', 'CHARGED', 'CHARGED_CONFIRM'].includes(type);

      // progress가 'INCOMPLETE'인 경우
      if (progress === 'INCOMPLETE' || progressCode === 'INCOMPLETE') {
        if (status === 'REGISTER') {
          if (this.course.getCancelType === 'free') return true;
        }

        if (this.course.getCancelType === 'charged') return true;
      }

      // progress가 'INCOMPLETE'가 아닌 경우
      const cancelableStatuses = ['AWAITING', 'APPROVAL_WAITING', 'PAYMENT_WAITING', 'APP_PAYMENT_WAITING'];

      if (progress !== 'INCOMPLETE' && progressCode !== 'INCOMPLETE' && cancelableStatuses.includes(status)) {
        return true;
      }

      if (status === 'REGISTER') {
        return true;
      }

      return false;
    },

    // 취소 타입 구분 (free 또는 charged)
    getCancelType() {
      const { status, type } = this.course;

      if (['FREE', 'FREE_CONFIRM'].includes(type)) {
        return 'free';
      } else if (['CHARGED', 'CHARGED_CONFIRM'].includes(type)) {
        if (status === 'REGISTER') {
          return 'charged';
        }
      }

      return 'free'; // 기본값
    },

    // 이수 여부
    completionStatus() {
      const { progress, status, passFail } = this.course;

      if (progress === 'CLOSED' || progress === '수강종료') {
        if (status === 'REGISTER') {
          return (passFail === 'PASS') ? '이수' : '미이수';
        }
      }

      return '';
    },

    // 이수증 출력 버튼 보여줄지 여부
    showCompletePrintBtn() {
      if (this.completionStatus === '이수') return true;
      return false;
    },
  },
  watch: {
    // 취소하기 모달 열릴 때 상세 모달 본문 aria-hidden 처리
    courseCancelModal(newVal) {
      this.$nextTick(() => {
        if (this.$refs.mainModalBody) {
          if (newVal) {
            this.$refs.mainModalBody.setAttribute('aria-hidden', 'true');
          } else {
            this.$refs.mainModalBody.removeAttribute('aria-hidden');
          }
        }
      });
    },
    // 연계 공고 모달 열릴 때 상세 모달 본문 aria-hidden 처리
    educationJobLinkModal(newVal) {
      this.$nextTick(() => {
        if (this.$refs.mainModalBody) {
          if (newVal) {
            this.$refs.mainModalBody.setAttribute('aria-hidden', 'true');
          } else {
            this.$refs.mainModalBody.removeAttribute('aria-hidden');
          }
        }
      });
    },
  },
  methods: {
    setButtons() {
      // DOM이 완전히 로드된 후 이벤트 등록
      this.$nextTick(() => {
        // 기존 이벤트 핸들러 제거 (중복 방지)
        $(document).off('click.detailModal', '.detailBtn');

        // 네임스페이스를 사용한 이벤트 등록
        $(document).on('click.detailModal', '.detailBtn', (event) => {
          event.preventDefault();
          const $target = $(event.currentTarget);
          this.id = $target.data('id');
          this.ck = $target.data('ck');
          this._triggerBtn = event.currentTarget; // 포커스 복원용 트리거 저장

          $('body').addClass('modal-open');
          this.showModal = true;
          this.getDetail();

          // 배경 콘텐츠 aria-hidden 처리
          Array.from(document.body.children).forEach((el) => {
            if (el.id !== 'detail-button') {
              el.setAttribute('aria-hidden', 'true');
            }
          });

          // 모달로 포커스 이동
          this.$nextTick(() => {
            if (this.$refs.mainModalBody) {
              this.$refs.mainModalBody.focus();
            }
          });
        });
      });
    },
    getDetail() {
      Axios.get(`/api/course/${this.id}/detail`).then((response) => {
        this.course = response.data.data.course;
        this.type = response.data.data.course.type;
        console.log(response.data);
      }).catch((e) => {
        alert(e.response.data.msg);
      });
    },
    openCashInfo() {
      this.cashInfoModal = true;
    },
    closeCashInfoModal() {
      this.cashInfoModal = false;
    },
    // 강좌와 연계된 공고 목록
    openEducationJobLink() {
      this.educationJobLinkModal = true;
    },
    closeEducationJobLink() {
      this.educationJobLinkModal = false;
      // 연계 공고 확인 버튼으로 포커스 복원
      this.$nextTick(() => {
        if (this.$refs.jobLinkBtn) {
          this.$refs.jobLinkBtn.focus();
        }
      });
    },
    completePrint() {
      window.open(`https://rpt.50plus.or.kr/mypage-pass-certrpt.do?id=${this.id}`, 'PopupWin', 'width=1000,height=600');
      // window.open(`/mypage-pass-certrpt.do?id=${this.id}`, 'PopupWin', 'width=1000,height=600');
    },
    closeModal() {
      $('body').removeClass('modal-open');
      this.showModal = false;

      // 배경 콘텐츠 aria-hidden 해제
      Array.from(document.body.children).forEach((el) => {
        el.removeAttribute('aria-hidden');
      });

      // 모달 열기 전 포커스 복원
      this.$nextTick(() => {
        if (this._triggerBtn) {
          this._triggerBtn.focus();
        }
      });
    },
    courseCancel() {
      this.courseCancelModal = true;
    },
    claseCourseCancelModal() {
      this.courseCancelModal = false;
    }
  },
  mounted() {
    // DOM 로드 완료 후 이벤트 설정
    setTimeout(() => {
      this.setButtons();
    }, 100);
  },
  beforeDestroy() {
    // 네임스페이스를 사용한 이벤트 제거
    $(document).off('click.detailModal', '.detailBtn');
  },
};
</script>



// WEBPACK FOOTER //
// MypageEducationDetail.vue?3eff45c8